/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getConsentFormWrapEarlyRequestRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService',
  rpcName: 'getConsentFormWrap',
  auth: 'app',
  fingerprint: 'ffznQ9qp3PVllPykvWpwuCZvnTu4aPTm',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getGdprWrapEarlyRequestRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsGDPRService',
  rpcName: 'getGdprWrap',
  auth: 'app',
  fingerprint: 'mNKFeLd1J76lV0_Krz8vIyZvnTu4aPTm',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};